// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2498":"6e0a2d2c","8428":"6e0a2d2c"}[chunkId] + ".chunk.css";
};